import { CustomSerializer, Schema } from '@bonusly/schema';

import { UserAPIData } from '../queries/users';
import { User } from './users';

export class ApprovalLevelSerializer extends CustomSerializer {
	deserialize(data: UserAPIData[][]): User[][] {
		return data.map((users) => Schema.deserialize(User, users));
	}

	serialize(data: User[][]): UserAPIData[][] {
		return data.map((users) => Schema.serialize(users));
	}
}
